import { useMutation } from '@tanstack/react-query';
import { scaffoldApi, type ScaffoldZipResult } from '../api/scaffoldApi';
import type { ApiError } from '../../common-showcase/types/showcase';
import type { ScaffoldRequest } from '../types/scaffold';

/**
 * Mutation: POST /api/eraf/scaffold/projects (queue #642)
 * 성공 시 blob+filename 을 반환 — 호출부(ScaffoldPreviewStep)가 브라우저 다운로드를 트리거한다
 * (#631/#641 blob 다운로드 패턴 재사용).
 */
export function useScaffoldGenerate() {
  return useMutation<ScaffoldZipResult, ApiError, ScaffoldRequest>({
    mutationFn: (req) => scaffoldApi.projects(req),
    mutationKey: ['project-scaffold', 'generate'],
  });
}
